<template>
  <div class="box">
    <!--  <div class="content-header">
      <div class="left">
        <span class="title">钱包管理</span>
      </div>
    </div> -->
    <div class="list-tab">
      <span :class="{ current: page.type == 1 }" @click="handleTypeSelectd(1)">收入</span>
      <span :class="{ current: page.type == 0 }" @click="handleTypeSelectd(0)">支出</span>
    </div>
    <div class="header_account">
      <div class="left">钱包余额：</div>
      <span class="money" style="font-size: 18px; color: #000; font-weight: bold">¥{{ (agent.agent_money /
        1000).toFixed(3) }}</span>
      <div class="right">
        <Button type="primary" style="margin-left: 20px" size="small"
          @click="showRechargeModal">&nbsp;&nbsp;&nbsp;&nbsp;充值&nbsp;&nbsp;&nbsp;&nbsp;</Button>
        <!-- <Button type="primary" @click="UpdateAgentInfo" size="small" style="margin-left: 10px">刷新余额</Button> -->
      </div>
    </div>

    <div class="filter-box">
      <span class="subtitle">查询时间:　</span>
      <DatePicker v-model="page.start" type="date" placeholder="开始日期" style="width: 130px; margin: 0 5px"
        :editable="false"></DatePicker>
      <span>至</span>
      <DatePicker v-model="page.end" type="date" placeholder="结束日期" style="width: 130px; margin: 0 5px"
        :editable="false">
      </DatePicker>
      <RadioGroup type="button" style="margin-left: 10px" v-model="radio" @on-change="onChangeSelectData">
        <Radio label="0">
          <span>本 周</span>
        </Radio>
        <Radio label="1">
          <span>本 月</span>
        </Radio>
        <Radio label="2">
          <span>上 月</span>
        </Radio>
      </RadioGroup>
    </div>
    <div class="bottom">
      <span class="btn-filter" @click="getData">筛选</span>
      <span class="btn" @click="reset">清空</span>
      <Poptip title="导出Excel" placement="right" trigger="hover">
        <span class="btn">导出报表</span>
        <div slot="content">
          <Button type="primary" style="margin-right: 5px" @click="exportData(0)">导出当前页</Button>
          <Button type="success" @click="exportData(1)">导出所有页</Button>
        </div>
      </Poptip>
    </div>

    <Table :loading="loading" :columns="columns" :data="tableData" style="margin-top: 20px"></Table>
    <div class="page-box" style="margin-top: 20px; text-align: right">
      <Page :total="total" :current="page.p + 1" :page-size="page.l" @on-change="pageChange"
        @on-page-size-change="sizeChange" show-sizer show-total />
    </div>

    <!-- 充值弹窗 -->
    <Modal v-model="rechargeModal.visible" title="账户充值" width="500">
      <Form :label-width="80" class="pay_content">
        <FormItem label="充值金额">
          <InputNumber :min="1" :precision="2" v-model="rechargeModal.money" placeholder="请输入充值金额"
            style="width: 100%" />
        </FormItem>

        <FormItem label="快捷选择">
          <div class="amount-buttons">
            <Button v-for="amount in [10, 100, 500, 800, 1000]" :key="amount"
              :type="rechargeModal.money === amount ? 'primary' : 'default'" @click="rechargeModal.money = amount"
              style="margin-right: 10px; margin-bottom: 10px">
              {{ amount }}元
            </Button>
          </div>
        </FormItem>

        <FormItem label="支付方式">
          <RadioGroup style="margin-top: 4px; padding-left: 10px; display: flex" v-model="rechargeModal.pay_type">
            <Radio :label="2" style="margin-right: 60px" class="radio">
              <img style="width: 26px" src="../../../assets/images/ic_alipay.png" />支付宝支付
            </Radio>
            <!-- <Radio :label="3" class="radio">
                <img class="pay_icon" src="../../../assets/images/ic_pay1.png" />
              </Radio> -->
          </RadioGroup>
        </FormItem>

      </Form>
      <div slot="footer">
        <Button @click="rechargeModal.visible = false">取消</Button>
        <Button type="primary" :loading="rechargeModal.loading" @click="doRecharge">{{ rechargeModal.isOpen ? '我已支付完成' :
        '去支付' }}</Button>
      </div>
    </Modal>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import excel from '@/libs/excel'
import { monDiff, verifyDate } from '@/libs/util'
export default {

  data () {
    return {
      visible: true,
      agentSwitch: true,
      loading: false,
      tableData: [],
      total: 0,
      rechargeModal: {
        visible: false,
        money: 100,
        loading: false,
        pay_type: 2,
        isOpen: false
      },
      radio: '0',
      page: {
        p: 0,
        l: 10,
        type: 1,
        start: '',
        end: ''
      },
      columns: [
        {
          title: '扩展ID',
          key: 'extend_id',
          width: 180
        },
        {
          title: '设备序列号',
          key: 'sn',
          width: 180,
          render: (h, params) => {
            return h('span', params.row.extend_data.sn || '-')
          }
        },
        {
          title: '文件页数',
          key: 'result_pages',
          width: 100,
          render: (h, params) => {
            return h('span', params.row.extend_data.total_pages || '-')
          }
        },
        {
          title: '交易时间',
          key: 'create_time',
          width: 200
        },
        {
          title: '交易类型',
          key: 'type',
          width: 100,
          render: (h, params) => {
            return h('span', params.row.type == 1 ? '收入' : '支出')
          }
        },
        {
          title: '业务类型',
          key: 'sub_type',
          width: 100,
          render: (h, params) => {
            const subTypes = {
              '0': '文档审查',
              '1': '充值'
            }
            return h('span', subTypes[params.row.type] || '-')
          }
        },
        {
          title: '交易金额',
          key: 'amount',
          width: 100,
          render: (h, params) => {
            const typeStr = params.row.type == 1 ? '+' : '-'
            return h('span', typeStr + (params.row.amount / 1000).toFixed(3))
          }
        },
        {
          title: '交易后余额',
          key: 'balance',
          width: 100,
          render: (h, params) => {
            return h('span', (params.row.balance / 1000).toFixed(3))
          }
        }

      ]
    }
  },
  mounted () {
    this.agentFuncShows()
    this.onChangeSelectData('0')
    this.getData()
    console.log('this.agent', this.agent)
    if (!this.agent.tp) {
      this.columns.splice(3, 0,
        {
          title: '合作伙伴',
          key: 'agent_name',
          with: 250
        }
      )
    }
  },
  methods: {
    ...mapActions(['MachineListConcise', 'SaveAgentFunc', 'getUserInfo', 'AgentIncrementRecharge', 'GetAgentMoneyBill']),
    async exportData (type) {
      const title = ['流水号', '交易时间', '交易类型', '业务类型', '交易金额', '交易后余额', '扩展ID']
      const key = ['serial_no', 'create_time', 'type', 'sub_type', 'amount', 'balance', 'extend_id']
      let data = []
      if (type === 0) {
        // 导出当前页
        data = this.tableData.map(item => ({
          ...item,
          type: item.type == 1 ? '收入' : '支出',
          sub_type: item.type == 0 ? '文档审查' : item.type == 1 ? '充值' : '-',
          amount: `${item.type == 1 ? '+' : '-'}${(item.amount / 1000).toFixed(3)}`,
          balance: (item.balance / 1000).toFixed(3)
        }))
      } else {
        // 导出所有页
        this.$Spin.show()
        try {
          const res = await this.GetAgentMoneyBill({
            ...this.page,
            start: this.$moment(this.page.start, 'YYYY-MM-DD'),
            end: this.$moment(this.page.end, 'YYYY-MM-DD'),
            p: 0,
            l: 100000
          })
          if (res.status) {
            data = res.data.map(item => ({
              ...item,
              type: item.type == 1 ? '收入' : '支出',
              sub_type: item.type == 0 ? '文档审查' : item.type == 1 ? '充值' : '-',
              amount: `${item.type == 1 ? '+' : '-'}${(item.amount / 1000).toFixed(3)}`,
              balance: (item.balance / 1000).toFixed(3),
              create_time: this.$moment(item.create_time, 'YYYY-MM-DD HH:mm:ss')
            }))
          } else {
            this.$Message.error(res.msg || '获取数据失败')
          }
        } catch (error) {
          this.$Message.error('导出失败')
        }
        this.$Spin.hide()
      }

      if (data.length < 1) {
        this.$Message.error('没有数据可导出')
        return
      }

      const filename = `钱包记录_${this.$moment(new Date(), 'YYYY-MM-DD HH:mm:ss')}`
      console.log('filename', filename)
      excel.export_array_to_excel({
        key,
        data,
        title,
        filename,
        autoWidth: true
      })
    },
    agentFuncShows () {
      // 开关
      console.log('funcs', this.agent.func)
      const funcs = this.agent.func ? this.agent.func.split(',') : []
      if (funcs.includes('fileCheck')) {
        this.agentSwitch = true
      } else {
        this.agentSwitch = false
      }
    },

    pageChange (p) {
      this.page.p = p - 1
      this.getData()
    },
    sizeChange (l) {
      this.page.l = l
      this.getData()
    },
    async agentSwitchChange (e) {
      let funcs = this.agent.func.split(',')
      if (e && !funcs.includes('fileCheck')) {
        console.log('includes')
        funcs.push('fileCheck')
      }
      if (!e && funcs.includes('fileCheck')) {
        console.log('cancel')
        for (let index = 0; index < funcs.length; index++) {
          const element = funcs[index]
          if (element === 'fileCheck') {
            funcs.splice(index, 1)
          }
        }
      }
      this.$Spin.show()
      const res = await this.SaveAgentFunc({ func: funcs.join(',') })

      if (!res.status) {
        this.$Message.error('请重试')
        // this.agentSwitch = false;
        this.agentFuncShows()
        this.$Spin.hide()
        return
      }
      await this.getUserInfo()
      this.agentFuncShows()
      this.$Spin.hide()
    },
    // 显示充值弹窗
    showRechargeModal () {
      this.rechargeModal.visible = true
      this.rechargeModal.money = 100
      this.rechargeModal.isOpen = false
    },
    // 执行充值
    async doRecharge () {
      if (this.rechargeModal.isOpen) {
        await this.getUserInfo()
        this.rechargeModal.visible = false
        return
      }
      if (this.rechargeModal.money <= 0) {
        this.$Message.error('充值金额有误')
        return
      }
      if (this.rechargeModal.money < 10) {
        this.$Message.error('最低充值10元')
        return
      }
      this.rechargeModal.loading = true
      try {
        const res = await this.AgentIncrementRecharge({
          money: this.rechargeModal.money,
          pay_type: 2
        })
        if (res) {
          // this.rechargeModal.visible = false;
          this.rechargeModal.isOpen = true
          window.open(`https://openapi.alipay.com/gateway.do?${res}`)
        } else {
          this.$Message.error('充值失败')
        }
      } catch (error) {
        this.$Message.error('充值失败')
      }
      this.rechargeModal.loading = false
    },
    async UpdateAgentInfo () {
      this.$Spin.show()
      await this.getUserInfo()
      this.$Spin.hide()
    },
    handleTypeSelectd (e) {
      this.page.type = e
      this.onChangeSelectData('0')
    },
    onChangeSelectData (e) {
      switch (e) {
        case '0': // 本周
          const now = new Date()

          const date = new Date()
          const dayOfWeek = date.getDay() // 获取当前是星期几 (0: 周日, 1: 周一, ..., 6: 周六)
          const diff = date.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1) // 计算本周周一的日期
          const startOfWeek = new Date(date.setDate(diff)) // 设置日期为本周周一
          startOfWeek.setHours(0, 0, 0, 0) // 将时间设置为 00:00:00

          this.page.start = this.$moment(startOfWeek, 'YYYY-MM-DD')
          this.page.end = this.$moment(now, 'YYYY-MM-DD')
          console.log('new', this.page)
          break
        case '1': // 本月
          this.curMonth(true)
          break
        case '2': // 上月
          this.curMonth()
          break
      }
      this.getData()
    },
    // 本月
    curMonth (isCur) {
      let now = new Date()
      let a = isCur ? 1 : 0
      let last = new Date(now.getFullYear(), now.getMonth() + a, 0)
      this.page.start = this.$moment(last, 'YYYY-MM') + '-01'
      this.page.end = this.$moment(last, 'YYYY-MM-DD')
    },
    async getData () {
      if (verifyDate(this.page.start, this.page.end)) {
        this.$Message.error('开始时间不能大于结束时间')
        return
      }
      if (monDiff(this.page.start, this.page.end) > 3) {
        // 如果时间跨度超过一年就提示
        this.$Message.error('筛选的时间跨度不能超过3个月')
        return
      }
      this.loading = true
      const res = await this.GetAgentMoneyBill({
        ...this.page,
        start: this.$moment(this.page.start, 'YYYY-MM-DD'),
        end: this.$moment(this.page.end, 'YYYY-MM-DD')
      })
      if (!res.status) {
        this.$Message.error(res.msg || '获取数据失败')
        return
      }
      res.data.map(element => {
        element.create_time = this.$moment(element.create_time, 'YYYY-MM-DD HH:mm:ss')
      })
      this.tableData = res.data
      this.total = res.total || 0
      this.loading = false
    },
    reset () {
      this.page = {
        p: 0,
        l: 10,
        type: this.page.type,
        start: '',
        end: ''
      }
      this.onChangeSelectData('0')
    }
  },
  computed: mapGetters({
    agent: 'agent'
  }),
  watch: {}
}
</script>
<style lang="less" scoped>
@import "./wallet.less";
</style>
